var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"dj-footer"},[_c('div',{staticClass:"footer-bottom t-a-c dj-container"},[_c('Row',[_c('i-col',[_c('span',[_vm._v(_vm._s(_vm.footer.list[0].copyright))]),_c('span',[_vm._v(_vm._s(_vm.footer.list[0].icp))])])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }